import { api } from '../config/api'

const emailBaseEndpoint = '/EmailApi/Contact'
const foundationEmailBaseEndpoint = '/EmailApi/FoundationContact'

export function sendContactForm(name, email, message, role) {
  return api.post(`${emailBaseEndpoint}`, { name, email, message, role })
}

export function sendFoundationContactForm(name, foundation, email, message) {
  return api.post(`${foundationEmailBaseEndpoint}`, { name, foundation, email, message })
}
